export type AdminRole = 'owner' | 'admin' | 'viewer';

export interface TournamentAdmin {
  id: string;
  tournamentId: string;
  userId: string;
  role: AdminRole;
  userEmail?: string; // Para mostrar en la UI
  userName?: string; // Para mostrar en la UI
  createdAt: Date;
}